import store, { AppDispatch } from "store";
export const useDispatch: () => AppDispatch = () => store.dispatch;
export default useDispatch;
